import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import DropMenu from '@roo/roo/DropMenu';
import Icon from '@roo/roo/Icon';
import { RootState } from '../../../../store';
import { IBusinessStatus, IBusinessStatusHandlerItem } from '../../../../api/define';
import styles from './BusinessStatus.module.scss';
import StatusHeader from './StatusHeader';
import StatusOperation from './StatusOperation';
import StatusTime from './StatusTime';
import StatusNotice from './StatusNotice';
import getStatusText from './getStatusText';

const { useState, useEffect } = React;

type BusinessStatusProps = {
    businessStatusInfo: IBusinessStatus;
    /** 获取商家营业状态信息 */
    getBusinessStatus: () => void;
};

const BusinessStatus: React.FC<BusinessStatusProps> = ({
    businessStatusInfo,
    getBusinessStatus,
}) => {
    /** 菜单展开状态 */
    const [menuVisible, setMenuVisible] = useState(false);
    /** 门店状态文案 */
    const [statusText, setStatusText] = useState('');
    /** 门店状态tag */
    const [statusTag, setStatusTag] = useState('');
    /** 门店状态操作栏 */
    const [statusItems, setStatusItems] = useState<IBusinessStatusHandlerItem[]>([]);

    useEffect(() => {
        getBusinessStatus();
    }, []);

    useEffect(() => {
        const { handlerItems, headerText, headerTag } = getStatusText(businessStatusInfo);
        setStatusText(headerText);
        setStatusTag(headerTag);
        setStatusItems(handlerItems);
    }, [businessStatusInfo, businessStatusInfo.wmPoiStatusDesc]);

    const renderPoiListTips = () => {
        return (
            <div className={styles.dropMenu}>
                {/* 营业状态文案 和 状态tag */}
                <StatusHeader statusText={statusText} statusTag={statusTag} />
                {/* 可操作部分，包括“恢复营业”“营业调整” */}
                <StatusOperation statusItems={statusItems} />
                <hr />
                {/* 营业时间 xx:xx:xx - xx:xx:xx */}
                <StatusTime />
                <hr />
                {/* 重要通知 */}
                <StatusNotice />
            </div>
        );
    };

    return (
        <div>
            <DropMenu
                placement="bottomRight"
                menuComponent={renderPoiListTips()}
                trigger="hover"
                flip={false}
                onVisibleChange={status => {
                    if (status) getBusinessStatus();
                    setMenuVisible(status);
                }}
            >
                <div className={styles.menuContainer}>
                    <span>{businessStatusInfo.wmPoiStatusDesc}</span>
                    {businessStatusInfo.hasSpecialShippingTime ? (
                        <span className={styles.notice}>
                            <i />
                        </span>
                    ) : null}

                    <Icon name={menuVisible ? 'chevron-up' : 'chevron-down'} size={12} />
                </div>
            </DropMenu>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        businessStatusInfo: state.shellHeader.poiBusinessStatus,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getBusinessStatus: () => {
        dispatch({ type: 'shellHeader/getBusinessStatus' });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(BusinessStatus);
